module.exports = __webpack_public_path__ + "static/media/mist-day.a9529240.svg";